<div class="layout" [ngClass]="{'collapsed': !appService.isSidebarOpen()}">
    <aside class="sidebar">
        <app-vertical-navigation [menu]="menu" [navigation]="navigation"></app-vertical-navigation>
    </aside>


    <div class="cuerpo-scroll-wrapper">
        <div class="cuerpo">
            <app-header class="header"></app-header>
            <main class="contenido">

                <router-outlet></router-outlet>
            </main>
            <footer class="footer">Factiva {{ year }} - Versión {{ version }} © {{ year }} Aurora System</footer>
        </div>
    </div>
</div>